import { render, staticRenderFns } from "./SalarysetChange.vue?vue&type=template&id=54ab2fa8"
import script from "./SalarysetChange.vue?vue&type=script&lang=js"
export * from "./SalarysetChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports